import React, { useContext, useMemo } from "react";
import { KeyMatrixContext } from "../context/KeyMatrixProvider";
import AutoCompleteDropdown from "@metacrm/metacrm-material-ui/dist/AutoCompleteDropdown";
import { Box } from "@mui/material";
import { formatDate } from "features/helpers/utils";
import moment from "moment";
import { useIntl } from "react-intl";

export default function KeyMatrixHeader() {
  const { granularity, setGranularityRange, range, setRange, rangeOptions } =
    useContext(KeyMatrixContext);
  const { formatMessage } = useIntl();
  const options = [
    {
      label: formatMessage({ id: "dropdown.timeInterval.daily" }),
      value: "daily",
    },
    // { label: "weekly", value: "weekly" },
    // { label: "monthly", value: "monthly" },
  ];

  // variable to get the time range based on the selected granularity and range by context use momentjs library
  const time = useMemo(() => {
    const unit = range.slice(-1); // 'd', 'w', 'm'
    const amount = parseInt(range.slice(0, -1), 10); // 數字部分
    // 計算起始日期
    const endDate = moment();
    const startDate = moment()
      .subtract(
        amount,
        unit === "d" ? "days" : unit === "w" ? "weeks" : "months"
      )
      .add(1, "days");
    const start = formatDate(startDate);
    const end = formatDate(endDate);
    return `${start} - ${end}`;
  }, [granularity, range]);

  return (
    <Box
      className="item-flex"
      justifyContent="space-between"
      bgcolor="white"
      p="0 16px"
      height="48px"
      borderRadius="4px"
    >
      <Box fontSize={12} color="#A5A5A5">
        {time}
      </Box>
      <Box className="item-flex" gap="8px">
        <Box width="120px" mr="8px">
          <AutoCompleteDropdown
            size="medium"
            value={options.find((option) => option.value === granularity)}
            placeholder={formatMessage({ id: "menu.placeholder.select" })}
            options={options}
            select
            onChange={(e, option) => setGranularityRange(option.value)}
          />
        </Box>

        {rangeOptions.map((option, index) => {
          const active = range === option;
          return (
            <Box
              sx={{
                p: "4px 8px",
                color: active ? "#7B61FF" : "#A5A5A5",
                border: active ? "1px solid #7B61FF" : "1px solid transparent",
                borderRadius: "4px",
                cursor: "pointer",
                "&:hover": {
                  color: "#7B61FF",
                  border: "1px solid #7B61FF",
                },
              }}
              key={index}
              onClick={() => setRange(option)}
            >
              {option}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
